<template>
    <v-dialog
            v-model="isOpen"
            :max-width="maxWidth"
            @keydown.esc.stop="close"
            @keydown.enter="$emit('enter')"
            @click:outside="close"
    >
        <TabBasic fixed-header sub-component>
            <template v-slot:header>
                <v-toolbar-title>
                    {{ title }}
                </v-toolbar-title>
                <v-spacer/>
                <v-btn icon @click="close">
                    <v-icon color="accentText">mdi-close</v-icon>
                </v-btn>
            </template>
            <div class="dialog-tab">
                <slot/>
            </div>
        </TabBasic>
    </v-dialog>
</template>

<script>


import TabBasic from "@/components/reusable/TabBasic/TabBasic";

export default {
  name: "Dialog",
  components: {TabBasic},
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    valid: {
      type: Boolean,
      required: false,
      default: true,
    },
    title: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    maxWidth: {
      type: String,
      required: false,
      default: '600px'
    },

  },
  computed: {
    isOpen() {
      return this.open;
    }
  },
  methods: {
    close(event) {
      this.$emit('close', event);
    },
    save() {
      this.$emit('save');
    }
  }
};
</script>

<style lang="scss" scoped>
@import "dialog";
</style>